import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchFormSubmissionById } from './dummyData';
import { FormSubmission } from './types';
import { ApplicantHero } from './components/ApplicantHero';
import { StatsGrid } from './components/StatsGrid';
import { AISummarySection } from './components/AISummarySection';
import { ImmigrationStatusCard } from './components/ImmigrationStatusCard';
import { ProfessionalCard } from './components/ProfessionalCard';
import { EvidenceSection } from './components/EvidenceSection';
import { DocumentsSection } from './components/DocumentsSection';
import styles from './form-submissions.module.css';
import { ArrowLeft, Loader } from 'lucide-react';

export function FormSubmissionDetails() {
  const { id } = useParams<{ id: string }>();
  const [submission, setSubmission] = useState<FormSubmission | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSubmission = async () => {
      if (!id) return;
      setLoading(true);
      const data = await fetchFormSubmissionById(id);
      setSubmission(data);
      setLoading(false);
    };
    loadSubmission();
  }, [id]);

  if (loading) {
    return (
      <div className={styles.container}>
        <div
          style={{
            minHeight: 'calc(100vh - 64px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Loader size={40} style={{ animation: 'spin 1s linear infinite', color: '#fa5d19' }} />
        </div>
      </div>
    );
  }

  if (!submission) {
    return (
      <div className={styles.container}>
        <div className={styles.pageWrapper}>
          <div className={styles.emptyState}>
            <h2 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '8px' }}>Not Found</h2>
            <p className={styles.emptyStateText}>This form submission could not be found.</p>
            <Link to="/forms" className={styles.backLink} style={{ marginTop: '16px' }}>
              <ArrowLeft size={14} />
              Back
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.pageWrapper}>
        {/* Back Button */}
        <Link to="/forms" className={styles.backLink}>
          <ArrowLeft size={14} />
          Back
        </Link>

        {/* Hero Section */}
        <ApplicantHero submission={submission} />

        {/* Stats Grid */}
        <StatsGrid submission={submission} />

        {/* AI Summary Section */}
        <AISummarySection submission={submission} />

        {/* Info Cards Grid */}
        <div className={styles.sectionGrid}>
          <ImmigrationStatusCard immigration={submission.immigration} />
          <ProfessionalCard professional={submission.professional} />
        </div>

        {/* Evidence Section */}
        <EvidenceSection evidence={submission.evidence} />

        {/* Documents Section */}
        <DocumentsSection submissionId={submission.id} />
      </div>
    </div>
  );
}
